<template>
  <div id="travel">
    <div id="content">
      <Header
        :page="'travel'"
        :title_one="'transfers'"
        :action_one="''"
      ></Header>
      <div
      class="description"
      v-html="$t('transfer.general_info_' + user.event_name.toLowerCase().replace(/ /g, ''))"
      ></div>
      <!-- ARRIVAL AND DEPARTURE SELECTOR -->
      <div class="bus-service-selectors">
        <!-- Selector: want bus service -->
        <div class="selector-row">
          <label for="busService">{{ $t('transfer.want_bus_service') }}</label>
          <select id="busService" v-model="busService">
            <option disabled value="">{{ $t('select_option') }}</option>
            <option value="yes">Sí</option>
            <option value="no">No</option>
          </select>
        </div>

        <!-- Selector: bus service type -->
        <div class="selector-row" v-if="busService === 'yes' && parseInt(event.type_id) == 1">
          <label for="busServiceType">{{ $t('transfer.bus_service_type') }}</label>
          <select id="busServiceType" v-model="busServiceType">
            <option disabled value="">{{ $t('select_option') }}</option>
            <option value="arrival">{{ $t('transfer.bus_arrival_only') }}</option>
            <option value="departure">{{ $t('transfer.bus_departure_only') }}</option>
            <option value="both">{{ $t('transfer.bus_arrival_departure') }}</option>
            <option value="other">{{ $t('transfer.bus_other_days') }}</option>
          </select>
        </div>

        <!-- Save button -->
        <div class="selector-actions">
          <button
            class="mainButton"
            :disabled="isSaving || isSaveDisabled"
            @click="saveBusService"
          >
            {{ isSaving ? $t('saving') : $t('save') }}
          </button>
        </div>
      </div>
      <div class="left" v-if="team.arribada_visible == '1'">
        <div class="title">{{ $t("transfer.arrival_title") }}</div>
        <template v-if="arrive == ''">
          <div class="row actions nobackground">
            <button
              v-if="event.transfers"
              class="mainButton"
              @click="addTravel(1)"
            >
              {{ $t("add") }}
            </button>
          </div>
        </template>
        <template v-else>
          <div class="row info">
            {{ $t("transfer.info_arrive") }}
          </div>
          <div class="row">
            <div class="item mid">
              <div class="label">{{ $t("params.transport_mode") }}</div>
              <div class="value">
                {{ transport_modes[arrive.transport_mode][0] }}
              </div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.transport_number") }}</div>
              <div class="value">{{ arrive.transport_number }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.transport_company") }}</div>
              <div class="value">{{ arrive.transport_company }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.origin_city") }}</div>
              <div class="value">{{ arrive.origin.city }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.destination") }}</div>
              <div class="value">
                {{
                  arrive.destination.entity_type != 0
                    ? getLocationName(
                        arrive.destination.entity_type,
                        arrive.destination.entity_id
                      )
                    : arrive.destination.name
                }}
              </div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.n_pax") }}</div>
              <div class="value">{{ arrive.pax }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.date") }}</div>
              <div class="value">{{ arrive.destination.date }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.hour") }}</div>
              <div class="value">{{ arrive.destination.hour }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.contact_name") }}</div>
              <div class="value">{{ arrive.contact_name }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.contact_phone") }}</div>
              <div class="value">{{ arrive.contact_phone }}</div>
            </div>

            <div class="item">
              <div class="label">{{ $t("params.observations") }}</div>
              <div class="value">{{ arrive.observations }}</div>
            </div>
            <div class="item center">
              <button
                v-if="event.transfers"
                class="mainButton center"
                @click="editTravel(arrive.id)"
              >
                {{ $t("edit") }}
              </button>
            </div>
          </div>
        </template>
        <div
          class="info"
          v-html="$t('transfer.arrival_info_' + user.event_name.toLowerCase().replace(/ /g, ''))"
        ></div>
      </div>

      <div class="right" v-if="team.sortida_visible == '1'">
        <div class="title">{{ $t("transfer.departure_title") }}</div>
        <template v-if="departure == ''">
          <div class="row actions nobackground">
            <button
              v-if="event.transfers"
              class="mainButton"
              @click="addTravel(3)"
            >
              {{ $t("add") }}
            </button>
          </div>
        </template>
        <template v-else>
          <div class="row info">
            {{ $t("transfer.info_departure") }}
          </div>
          <div class="row">
            <div class="item mid">
              <div class="label">{{ $t("params.transport_mode") }}</div>
              <div class="value">
                {{ transport_modes[departure.transport_mode][0] }}
              </div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.transport_number") }}</div>
              <div class="value">{{ departure.transport_number }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.transport_company") }}</div>
              <div class="value">{{ departure.transport_company }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.origin") }}</div>
              <div class="value">
                {{
                  departure.origin.entity_type != 0
                    ? getLocationName(
                        departure.origin.entity_type,
                        departure.origin.entity_id
                      )
                    : departure.origin.name
                }}
              </div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.destination") }}</div>
              <div class="value">{{ departure.destination.city }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.n_pax") }}</div>
              <div class="value">{{ departure.pax }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.date") }}</div>
              <div class="value">{{ departure.origin.date }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.hour") }}</div>
              <div class="value">{{ departure.origin.hour }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.contact_name") }}</div>
              <div class="value">{{ departure.contact_name }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.contact_phone") }}</div>
              <div class="value">{{ departure.contact_phone }}</div>
            </div>

            <div class="item">
              <div class="label">{{ $t("params.observations") }}</div>
              <div class="value">{{ departure.observations }}</div>
            </div>

            <div class="item center">
              <button
                v-if="event.transfers"
                class="mainButton center"
                @click="editTravel(departure.id)"
              >
                {{ $t("edit") }}
              </button>
            </div>
          </div>
        </template>
        <div
          class="info"
          v-html="
            $t('transfer.departure_info_' + user.event_name.toLowerCase().replace(/ /g, ''))
          "
        ></div>
      </div>

      <div class="section" v-if="Object.values(travelInternal).length > 0">
        <span class="title">{{ $t("titles.my_transfers") }}</span>

        <v-data-table
          class="dataTable"
          id="players"
          :headers="tableHeaders"
          :items="Object.values(travelInternal)"
          :no-data-text="''"
          :no-results-text="'Hola'"
          :hideActions="true"
          :pagination.sync="pagination"
        >
          <template v-slot:items="props">
            <td>{{ transport_modes[props.item.transport_mode][0] }}</td>
            <td>{{ props.item.transport_number }}</td>
            <td>{{ props.item.transport_company }}</td>
            <td v-if="props.item.type == '1'">
              {{ props.item.destination.date }}
            </td>
            <td v-else>{{ props.item.origin.date }}</td>
            <td v-if="props.item.type == '1'">
              {{ props.item.destination.hour }}
            </td>
            <td v-else>{{ props.item.origin.hour }}</td>
            <td
              v-if="
                props.item.origin.entity_type != '0' &&
                  props.item.origin.entity_id == null
              "
            >
              {{ $t("undefined") }}
            </td>
            <td v-else-if="props.item.origin.entity_type != '0'">
              {{
                getLocationTransfer(
                  props.item.origin.entity_type,
                  props.item.origin.entity_id
                ).name
              }}
            </td>
            <td v-else>{{ props.item.origin.name }}</td>
            <td
              v-if="
                props.item.destination.entity_type != '0' &&
                  props.item.destination.entity_id == null
              "
            >
              {{ $t("undefined") }}
            </td>
            <td v-else-if="props.item.destination.entity_type != '0'">
              {{
                getLocationTransfer(
                  props.item.destination.entity_type,
                  props.item.destination.entity_id
                ).name
              }}
            </td>
            <td v-else>{{ props.item.destination.name }}</td>
            <td>{{ props.item.pax }}</td>
            <td v-if="props.item.cost != null">{{ props.item.cost }}€</td>
            <td v-else>-</td>
            <td>{{ props.item.observations }}</td>
          </template>
        </v-data-table>
      </div>

      <div class="section" v-if="Object.values(travelCompetition).length > 0">
        <span class="title">{{ $t("titles.my_transfers_competition") }}</span>
        <div class="description" v-html="$t('transfer.transfer_competition_info')"></div>
        <v-data-table
          class="dataTable"
          id="transfers-competition"
          :headers="tableHeadersCompetition"
          :items="Object.values(travelCompetition)"
          :no-data-text="''"
          :no-results-text="'Hola'"
          :hideActions="true"
          :pagination.sync="pagination"
        >
          <template v-slot:items="props">
            <td>{{ transport_modes[props.item.transport_mode][0] }}</td>
            <!-- <td>{{ props.item.transport_number }}</td> -->
            <td>{{ props.item.transport_company }}</td>
            <td v-if="props.item.type == '1'">
              {{ props.item.destination.date }}
            </td>
            <td v-else>{{ props.item.origin.date }}</td>
            <td v-if="props.item.type == '1'">
              {{ props.item.destination.hour }}
            </td>
            <td v-else>{{ props.item.origin.hour }}</td>
            <td
              v-if="
                props.item.origin.entity_type != '0' &&
                  props.item.origin.entity_id == null
              "
            >
              {{ $t("undefined") }}
            </td>
            <td v-else-if="props.item.origin.entity_type != '0'">
              {{
                getLocationTransfer(
                  props.item.origin.entity_type,
                  props.item.origin.entity_id
                ).name
              }}
            </td>
            <td v-else>{{ props.item.origin.name }}</td>
            <td
              v-if="
                props.item.destination.entity_type != '0' &&
                  props.item.destination.entity_id == null
              "
            >
              {{ $t("undefined") }}
            </td>
            <td v-else-if="props.item.destination.entity_type != '0'">
              {{
                getLocationTransfer(
                  props.item.destination.entity_type,
                  props.item.destination.entity_id
                ).name
              }}
            </td>
            <td v-else>{{ props.item.destination.name }}</td>
            <td>{{ props.item.pax }}</td>
            <!-- <td v-if="props.item.cost != null">{{ props.item.cost }}€</td>
            <td v-else>-</td> -->
            <td>{{ props.item.observations }}</td>
          </template>
        </v-data-table>
      </div>
    </div>
    <!-- Simple message dialog -->
    <v-dialog v-model="dialogVisible" max-width="400">
      <v-card class="pa-4">
        <v-card-title
          :class="dialogType === 'success' ? 'green--text text--darken-2' : 'red--text text--darken-2'"
        >
          {{ dialogTitle }}
        </v-card-title>

        <v-card-text>{{ dialogMessage }}</v-card-text>

        <v-card-actions class="justify-end">
          <v-btn color="primary" text class="black--text" @click="dialogVisible = false">
            {{ $t('ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import i18n from '@/i18n'
import Header from '@/components/layout/Header'

export default {
  name: 'travel',
  components: {
    Header
  },
  data () {
    return {
      busService: '',
      busServiceType: '',
      isSaving: false,
      dialogVisible: false,
      dialogTitle: '',
      dialogMessage: '',
      dialogType: 'success',
      type: '',
      title_two: '',
      // user: {},
      countries: {},
      positions: {},
      alergies: {},
      staff_level: {},
      diets: {},
      contact_type: {},
      pagination: {
        sortBy: [
          { key: 'origin.date', order: 'asc' },
          { key: 'origin.hour', order: 'asc' }
        ],
        descending: false,
        rowsPerPage: -1
      },
      error: {
        responsable: false
      },

      travel: {
        1: {
          transport_mode: 1,
          transport_number: '5874',
          transport_company: 'ALSA',
          origin: {
            entity_id: 2,
            name: 'Aeroport T1',
            date: '25/12/2019',
            hour: '10:58'
          },
          destination: {
            entity_id: 1,
            name: 'Maremagnum'
          },
          n_pax: 50,
          cost: 500,
          observations: 'Ninguna'
        },
        2: {
          transport_mode: 1,
          transport_number: '5874',
          transport_company: 'ALSA',
          origin: {
            entity_id: 2,
            name: 'Aeroport T1',
            date: '25/12/2019',
            hour: '10:58'
          },
          destination: {
            entity_id: 1,
            name: 'Maremagnum'
          },
          n_pax: 50,
          cost: 500,
          observations: 'Ninguna'
        }
      },
      tableHeaders: [
        {
          text: i18n.t('params.transport_mode'),
          value: 'transport_mode',
          sortable: true
        },
        {
          text: i18n.t('params.transport_number'),
          value: 'transport_number',
          sortable: false
        },
        {
          text: i18n.t('params.transport_company'),
          value: 'transport_company',
          sortable: true
        },
        { text: i18n.t('params.date'), value: 'origin.date', sortable: true },
        { text: i18n.t('params.hour'), value: 'origin.hour', sortable: true },
        {
          text: i18n.t('params.origin_place'),
          value: 'origin.entity_id',
          sortable: true
        },
        {
          text: i18n.t('params.destination'),
          value: 'destination.entity_id',
          sortable: true
        },
        { text: i18n.t('params.n_pax'), value: 'pax', sortable: true },
        { text: i18n.t('params.cost'), value: 'cost', sortable: true },
        {
          text: i18n.t('params.observations'),
          value: 'observations',
          sortable: false
        }
      ],

      tableHeadersCompetition: [
        {
          text: i18n.t('params.transport_mode'),
          value: 'transport_mode',
          sortable: true
        },
        // {
        //   text: i18n.t('params.transport_number'),
        //   value: 'transport_number',
        //   sortable: false
        // },
        {
          text: i18n.t('params.transport_company'),
          value: 'transport_company',
          sortable: true
        },
        { text: i18n.t('params.date'), value: 'origin.date', sortable: true },
        { text: i18n.t('params.hour'), value: 'origin.hour', sortable: true },
        {
          text: i18n.t('params.origin_place'),
          value: 'origin.entity_id',
          sortable: true
        },
        {
          text: i18n.t('params.destination'),
          value: 'destination.entity_id',
          sortable: true
        },
        { text: i18n.t('params.n_pax'), value: 'pax', sortable: true },
        // { text: i18n.t('params.cost'), value: 'cost', sortable: true },
        {
          text: i18n.t('params.observations'),
          value: 'observations',
          sortable: false
        }
      ],

      arrive: '',
      departure: ''
    }
  },
  computed: {
    isSaveDisabled () {
      // Case 1: nothing selected
      if (!this.busService && parseInt(this.event.type_id) == 1) return true

      // Case 2: user chose "yes" but hasn’t selected service type
      if (this.busService === 'yes' && !this.busServiceType && parseInt(this.event.type_id) == 1) return true

      // Otherwise enabled
      return false
    },
    team () {
      return this.user.admin
        ? this.$store.getters['club/getClub'].teams[this.$route.params.team_id]
        : this.$store.getters['team/getTeam'].team
    },

    travels () {
      var list = this.$store.getters['travel/getList']
      var findArrive = Object.values(list).find(obj => {
        return obj.type == 1
      })
      findArrive ? (this.arrive = findArrive) : (this.arrive = '')

      var findDesparture = Object.values(list).find(obj => {
        return obj.type == 3
      })
      findDesparture
        ? (this.departure = findDesparture)
        : (this.departure = '')

      return list
    },

    travelInternal () {
      var result = {}
      if (Object.values(this.travels).length > 0) {
        for (var key in this.travels) {
          var item = this.travels[key]
          if (item.type == '2') {
            result[key] = item
          }
        }
      }
      return result
    },

    travelCompetition () {
      var result = {}
      if (Object.values(this.travels).length > 0) {
        for (var key in this.travels) {
          var item = this.travels[key]
          if (item.type == '4') {
            result[key] = item
          }
        }
      }
      return result
    },

    locations () {
      return this.$store.getters['travel/getLocations']()
    },

    hotels () {
      return this.$store.getters['travel/getHotels']()
    },

    facilities () {
      return this.$store.getters['travel/getFacilities']()
    },

    transport_modes () {
      var oOptions = this.$store.getters.getTransportMode()
      var aResult = []
      for (var k in oOptions) {
        aResult[oOptions[k].id] = []
        aResult[oOptions[k].id].push(
          i18n.t('transfer.transport_mode.' + oOptions[k].name)
        )
      }
      return aResult
    },

    user () {
      return this.$store.getters['user/getUser']
    },

    event () {
      return this.$store.getters['getCurrentEvent']()
    }
  },
  created () {
    this.load()
  },
  methods: {
    async saveBusService () {
      if (!this.busService) {
        this.dialogTitle = this.$t('error_saving')
        this.dialogMessage = this.$t('select_option')
        this.dialogType = 'error'
        this.dialogVisible = true
        return
      }

      this.isSaving = true

      try {
        const resp = await this.$store.dispatch('travel/setTransferOptions', {
          team_id: this.$route.params.team_id,
          transfer_options: {
            want_bus_service: this.busService,
            bus_service_type: this.busServiceType
          }
        })

        if (!resp || resp.status !== true) {
          throw new Error('Error saving bus service')
        }

        this.dialogTitle = this.$t('saved_successfully')
        this.dialogMessage = this.$t('bus_service_saved')
        this.dialogType = 'success'
        this.dialogVisible = true

        console.log('Bus service saved!')
      } catch (err) {
        console.error('Error saving bus service', err)
        this.dialogTitle = this.$t('error_saving')
        this.dialogMessage = this.$t('try_again_later')
        this.dialogType = 'error'
        this.dialogVisible = true
      } finally {
        this.isSaving = false
      }
    },
    async load() {
      this.$overlay.show()
      window.scroll(0, 0)

      try {
        const teamId = this.$route.params.team_id

        if (this.user.admin) {
          await this.$store.dispatch('club/loadClubEvent', {
            club_id: this.user.club_id,
            event_id: this.user.event_id
          })
        } else {
          await this.$store.dispatch('team/loadTeam', {
            team_id: teamId
          })
        }

        await this.$store.dispatch('travel/loadTravelInfo')

        await this.$store.dispatch('travel/loadTeamTravels', {
          team_id: teamId
        })

        const resp = await this.$store.dispatch('travel/getTransferOptions', {
          team_id: teamId
        })

        console.log('Loaded transfer options:', resp)
        if (
          resp &&
          resp.data
        ) {
          this.busService = resp.data.want_bus_service || ''
          this.busServiceType = resp.data.bus_service_type || ''
        }
      } catch (err) {
        console.error('Error loading travel data:', err)
      } finally {
        this.$overlay.hide()
      }
    },

    addTravel (type) {
      this.$router.push({ name: 'travel_add', params: { type: type } })
    },

    editTravel (id) {
      this.$router.push({ name: 'travel_edit', params: { id: id } })
    },

    getLocationTransfer (entity_type, entity_id) {
      // console.log("getLocationTransfer",entity_type,entity_id)
      if (parseInt(entity_type) == 4) {
        console.log(
          'HOTEL',
          this.$store.getters['travel/getHotels']()[entity_id]
        )
        return this.$store.getters['travel/getHotels']()[entity_id]
      } else if (parseInt(entity_type) == 5) {
        console.log(
          'FACILITY',
          this.$store.getters['travel/getFacilities']()[entity_id]
        )
        return this.$store.getters['travel/getFacilities']()[entity_id]
      } else if (parseInt(entity_type) == 11) {
        var locations = this.$store.getters['travel/getLocations']()
        console.log('LOCATION', locations[entity_id])
        return locations[entity_id] ? locations[entity_id] : ''
      }
    },

    getLocationName (entity_type, entity_id) {
      if (parseInt(entity_type) == 4) {
        return this.hotels[entity_id].name
      } else if (parseInt(entity_type) == 5) {
        return this.facilities[entity_id].name
      } else if (parseInt(entity_type) == 11) {
        return this.locations[entity_id] ? this.locations[entity_id].name : ''
      }
    }
  },
  watch: {
    $route: 'load'
  }
}
</script>
<style lang="scss" scoped>
.mobile {
  display: none;
}

#content {
  padding: 0 12px !important;
  padding-bottom: 50px !important;

  .row {
    background-color: #f5f5f5;
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    margin-bottom: 24px;
    padding: 6px 12px;
    height: auto;
    // min-height: 100px;

    &.info {
      text-align: left !important;
    }

    &.nobackground {
      background-color: unset;
    }

    .item {
      display: inline-block;
      margin-bottom: 6px;
      width: 100%;

      &.mid {
        width: 50%;
      }
      &.center {
        text-align: center;
      }

      .alergy {
        color: inherit;
        font-size: inherit;
        font-weight: inherit;

        &:after {
          content: ", ";
        }
        &:last-of-type:after {
          content: "";
        }
      }
    }

    .label,
    .value {
      display: inline-block;
      font-size: 15px;
    }
    .label {
      width: 100px;
      text-align: right;
      margin-right: 12px;
      text-transform: uppercase;
      font-size: 12px;

      &:after {
        content: ":";
      }
    }
    .value {
      font-weight: bold;
    }
  }

  .title {
    font-size: 16px !important;
    font-weight: bold;
    color: #191919;
    display: block;
    width: 100%;
    margin: 6px;
    font-family: AvantGarde-Bold !important;
    text-transform: uppercase;
    padding: 2px 0;

    &.sub {
      margin-left: 12px;
    }
  }

  .travel {
    background: none;
    width: 100%;
    overflow: hidden;
    text-align: left;

    .travel-role,
    .travel-name {
      @include text-ellipsis();
      display: block;
      font-size: 24px;
      color: $main-color;
      width: 100%;
      padding: 2px;
    }

    .travel-role {
      margin-right: 6px;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 16px;
      line-height: 16px;
    }
  }

  .left,
  .right {
    width: 50%;
    display: inline-block;
    padding: 12px;
  }
  .left {
  }
  .right {
  }
}

@include media("<=desktop") {
  #content {
    padding: 12px !important;

    .left,
    .right {
      width: 100%;
      display: block;
      padding: 0;
    }
  }
}

@include media(">phone", "<tablet") {
  #content {
    .row {
      .item {
        &.mid {
          width: 100%;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.mainButton {
  width: 150px !important;
  padding: 0;
  margin: 0;
  height: 100%;
  min-width: 40px;
  outline: none;
  cursor: pointer;
  font-size: 8pt;
  font-family: Speedee-Bold;
  border-radius: 3px;
  border: 1px solid #fc8926;
  text-transform: uppercase;
  background-color: transparent;
  color: #c55c00;
  height: 40px;
  padding: 0;
  font-family: Roboto-Bold;
  font-size: 14px;
  line-height: 14px;
  transition: background-color 0.5s ease;
  float: left;

  &.center {
    float: none;
  }

  &:hover {
    background-color: #fc8a2623 !important;
  }
}

.section {
  float: left;
  display: block;
  width: 100%;
}

.search {
  float: right;
}

.dataTable {
  > div {
    table {
      text-align: center;
      width: 100%;
      margin: 20px auto 0;
      border-radius: 5px;

      overflow: visible;
      min-width: 600px;

      th {
        background-color: $secondary-color;
        background-color: #ddd;
      }
      td,
      th {
        border: 1px solid $secondary-color;
        padding: 12px !important;
        text-align: left;
        border-left: 0;
        border-right: 0;
        min-width: 60px;
      }

      tr:nth-child(even) {
        background-color: #f7f7f7;
      }

      th {
        font-weight: normal;
        border: 0 solid $secondary-color;
        color: $main-color;
        color: #333;
        padding: 20px;
        text-transform: uppercase;
      }
      th.column[role="columnheader"] {
        padding: 20px 12px 12px 12px !important;
      }

      th:nth-child(1) {
        width: 20%;
      }

      th:nth-child(2) {
        width: 20%;
      }

      th:nth-child(3) {
        width: 20%;
      }

      th:nth-child(4) {
        width: 20%;
      }

      th:nth-child(5) {
        width: 10%;
      }

      th:nth-child(6) {
        width: 10%;
      }

      tr:last-child {
        // border-bottom: 4px solid $main-color;
      }
    }
  }
}
.bus-service-selectors {
  margin: 20px 0;
  padding: 16px 20px;
  background: #fffaf0;
  border: 1px solid #f1a30055;
  border-radius: 6px;
  overflow: hidden; /* <-- prevents internal floats from overflowing */

  .selector-row {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    label {
      font-weight: 600;
      font-size: 14px;
      color: #222;
      margin-bottom: 6px;
    }

    select {
      width: 100%;
      max-width: 320px;
      padding: 8px 10px;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-size: 14px;
      font-family: inherit;
      background-color: #fff;
      transition: border-color 0.2s ease;

      &:focus {
        border-color: #f1a300;
        outline: none;
      }
    }
  }

  .selector-actions {
    margin-top: 12px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .mainButton {
      float: none; /* <-- neutralize old float rule */
      width: auto;
      padding: 8px 20px;
      height: auto;
    }
  }

  @media (max-width: 768px) {
    padding: 12px;
    .selector-row select {
      max-width: 100%;
    }
  }
}

.mainButton:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
